import { useEffect } from "react";
import { useRouter, useLocation } from "@tanstack/react-router";

/**
 * Legacy English-style Spanish service URLs (/es/services/...) send visitors to
 * the published Spanish routes under /es/servicios/...
 */
export default function LegacyEsServicesRedirect() {
  const router = useRouter();
  const location = useLocation();
  const target =
    location.pathname.replace("/es/services/", "/es/servicios/") +
    (location.searchStr ?? "") +
    (location.hash ? `#${location.hash}` : "");

  useEffect(() => {
    router.navigate({ href: target, replace: true });
  }, [router, target]);

  return null;
}
